import { View, Text, Dimensions, Image } from "react-native";
import React from "react";
import {
  femaleColor,
  gray,
  green,
  maleColor,
  orange,
  primary,
  success,
  white,
} from "../../colors";
import {
  height,
  loadingGif,
  newChild,
  testChildren,
  tests,
  tutorial,
  width,
} from "../../imports";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import { changeHeaderColor } from "../../redux/header/headerAction";
import { useEffect } from "react";
import { useState } from "react";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import TestItem from "../../components/test/TestItem";
import Header from "../../components/header/Header";
import { ScrollView } from "react-native-gesture-handler";
import MyButton from "../../components/custom/MyButton";
import AnswerReviewItem from "../../components/test/AnswerReviewItem";
import saveTestAnswer from "../../api/test/saveTestAnswer";

export default function AnswerReview({ route }) {
  const { test, type, answer, part, userDetails } = route.params;
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [selectedChild, setChild] = useState({ gender: "male", name: "ahmad" });
  const [submittingLoading, setSubmittingLoading] = useState(false);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fff"));
    }
  }, [isFocused]);
  const testLength = test.length;
  useEffect(() => {}, []);

  const setTestAnswer = () => {
    setSubmittingLoading(true);

    saveTestAnswer(
      userDetails.childId,
      userDetails.testId,
      type,
      answer,
      type === "ASQ3" ? part : type
    )
      .then(({ data }) => {
        setSubmittingLoading(false);

        navigation.navigate("TestNavigator");
      })
      .catch((err) => {
        setSubmittingLoading(false);
      });
  };
  if (submittingLoading) {
    return (
      <View
        style={{
          width: width,
          height: height,
          backgroundColor: "#FF9800",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          source={loadingGif}
          style={{ width: width / 2, height: width / 2 }}
        />
        <MyText style={{ color: white, fontSize: 22 }}>
          {translate("please wait")}
        </MyText>
        <MyText style={{ color: gray, fontSize: 18, marginTop: 10 }}>
          {translate("preparing test result")}
        </MyText>
      </View>
    );
  }
  return (
    <View style={{ flex: 1, alignItems: "center" }}>
      <Header notOpenDrawer={true} />
      <ScrollView style={{ flex: 1 }}>
        <View
          style={{
            width: "100%",
            alignItems: "center",
            flex: 1,
            paddingBottom: 100,
          }}
        >
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                height: Dimensions.get("window").height,
                marginTop: -1 * Dimensions.get("window").height,
                backgroundColor: "#fff",
                width: "100%",
              }}
            ></View>
            <View style={{ alignItems: "center" }}>
              <View style={{ backgroundColor: "#fff" }}>
                <View
                  style={{
                    backgroundColor: "#fff",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                    width: Dimensions.get("screen").width,
                    minHeight: 200,
                    flexDirection: "row",
                    paddingHorizontal: 10,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Image
                      source={newChild}
                      style={{ width: "100%", height: 207 }}
                      resizeMode="contain"
                    />
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View></View>
          <MyText
            style={{
              marginTop: 10,
              fontSize: 20,
              fontWeight: "bold",
              color: primary,
            }}
          >
            {`آزمون ${type}`}
          </MyText>
          {type === "ASQ3" && (
            <MyText
              style={{
                marginVertical: 5,
                fontSize: 16,

                color: gray,
              }}
            >
              {translate(route.params.part)}
            </MyText>
          )}
          <View style={{ width: "95%" }}>
            <MyText style={{ fontSize: 20, color: gray }}>
              {translate("test review")}
            </MyText>
            <MyText style={{ fontSize: 14, color: gray }}>
              {translate("you can edit questions by touching them")}
            </MyText>
            {test.map((item, index) => (
              <AnswerReviewItem
                onPress={() => {
                  navigation.navigate("TestReview", {
                    answers: answer,
                    question: item,
                    questionCount: testLength,
                    test: test,
                    type: type,
                    part: part,
                    userDetails: userDetails,
                  });
                }}
                key={index}
                number={index + 1}
                text={main.rtl ? item.titleFa : item.titleEn}
                answer={answer.find(
                  (answerItem, index) => answerItem.id === item.id
                )}
              />
            ))}
          </View>
          <MyButton
            onPress={setTestAnswer}
            style={{
              width: "90%",
              paddingVertical: 15,
              backgroundColor: "#FF9800",
              marginTop: 20,
            }}
            text={translate("submit answers and see result")}
          />
        </View>
      </ScrollView>
      {/* <View style={{ width: "90%" }}>
        <MyButton
          onPress={() =>
            navigation.navigate("TestQuestion", {
              test: details.question,
              questionNumber: 1,
              answer: {},
            })
          }
          text={translate("start doing test")}
          style={{
            backgroundColor: green,
            paddingVertical: 15,
            marginBottom: 30,
          }}
        />
      </View> */}
    </View>
  );
}
